export enum EHousingFinancialTypes {
  LEASE = 'lease',
  MORTGAGE = 'mortgage',
  NONE = 'none'
}
